import { BeneficiaryModifiedDiscrepancy, DeletedBeneficiary, Reference } from '@approvalmax/types';
import { backend, domain } from 'modules/data';
import { PropsWithChildren } from 'react';

import { RequestEditMode } from '../../../selectors/requestSelectors';

export interface FilterTrasferData
    extends Omit<
        backend.transfers.BillRequestsForAirwallexBatchPaymentTransfer,
        'companyId' | 'airwallexXeroBatchPaymentRequestId'
    > {}

export enum SortingDirection {
    Ascending = 'Ascending',
    Descending = 'Descending',
}
export interface AddBeneficiaryPopupData {
    isOpen: boolean;
    initialBillCurrency?: string;
    initialBillId?: string;
}

export type CheckBeneficiaryResult = {
    status: domain.BeneficiaryPaymentStatus;
    beneficiaryDiscrepancy: domain.BeneficiaryLastPaymentDiscrepancy | null;
};

export interface XeroAirwallexBatchPaymentFormContextType {
    billBatchPayment: domain.XeroAirwallexBatchPayment;
    setBillBatchPayment: (
        newBillBatchPayment: domain.XeroAirwallexBatchPayment,
        propName: keyof domain.XeroAirwallexBatchPayment
    ) => void;
    showErrors: boolean;
    setShowErrors: (newValue: boolean) => void;
    saveAndSubmit: (commentText?: string) => void;
    clearItems: () => void;
    addBills: (selectableBills: domain.AirwallexBatchSelectableBillItem[]) => void;
    removeSelectableBillById: (xeroBillInvoiceRequestId: string) => void;
    changeBillInvoiceItemField: (
        xeroBillInvoiceRequestId: string,
        itemField: keyof domain.AirwallexPaymentItem,
        newValue: domain.AirwallexPaymentItem[keyof domain.AirwallexPaymentItem]
    ) => void;
    changePaymentMethod: (xeroBillInvoiceRequestId: string, paymentMethod: Reference | null) => void;
    changeBeneficiary: (xeroBillInvoiceRequestId: string, beneficiary: domain.AirwallexBeneficiary | null) => void;
    changeBankAccount: (
        xeroBillInvoiceRequestId: string,
        bankAccount: Reference | null,
        sourceCurrency: Reference | null
    ) => void;
    billInvoiceRequestIdsWithError: string[];
    billInvoiceRequestIdsWithExceededAmount: string[];
    updateAirwallexBillBatchPayment: (billBatchPayment: domain.XeroAirwallexBatchPaymentDetails) => void;
    isSaving: boolean;
    companyId: string;
    companyCurrency: string;
    canCreateBeneficiary: boolean;
    checkBeneficiaryResultsByInvoiceId: Record<string, CheckBeneficiaryResult>;
    setCheckBeneficiaryResultsByInvoiceId: (checkBeneficiaryResult: Record<string, CheckBeneficiaryResult>) => void;
    applyChangedBeneficiaries: (beneficiaries: { id: string; version: number }[]) => void;
    deletedBeneficiariesData: DeletedBeneficiary[] | null;
    setDeletedBeneficiariesData: (deletedBeneficiariesData: DeletedBeneficiary[] | null) => void;
    changedBeneficiariesData: BeneficiaryModifiedDiscrepancy[] | null;
    setChangedBeneficiariesData: (changedBeneficiariesData: BeneficiaryModifiedDiscrepancy[] | null) => void;
    editMode: RequestEditMode;
    removeLinesDisabled: boolean;
}

export interface XeroAirwallexBatchPaymentFormContextProviderProps extends PropsWithChildren {
    request: domain.XeroAirwallexBatchPaymentRequest;
    editRequestField: <TDetails, TKey extends keyof TDetails = keyof TDetails>(
        propName: TKey,
        newValue: TDetails[TKey]
    ) => void;
}
